export default "__VITE_ASSET__CsI1u4mr__"